import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { TranslateService } from '@ngx-translate/core';
import { environment } from 'environments/environment';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable()
export class LanguagesStaticText {
  apiUrl = environment.apiHost;
  languages = {Portuguese: 'pt', English: "en"}
  private language_configs = new BehaviorSubject<any>([]);
  private user_languages = new BehaviorSubject<any>([]);
  public language_configs$ = this.language_configs.asObservable();




  constructor (private http: Http, 
    private translate: TranslateService,
  ) {
    this.getLanguagesUrl().subscribe((res: any) => {
      const languages = JSON.parse(res._body)
      this.setLanguageConfigs(languages);
    });


  }

  getLanguagesUrl() {
    return this.http.get(this.apiUrl+'/api/language_configs/')
  }
  getLanguages(url: string) {
    return this.http.get(url)
  }
  public setLanguageConfigs(data: any) {
    this.language_configs.next(data)
  }
  public getLanguageConfigs(): Observable<any> {
    return this.language_configs$;
    // return this.language_configs.asObservable();
  }
  public setUserLanguages(data: any) {
    this.user_languages.next(data)
  }
  public getUserLanguages(): Observable<any> {
    return this.user_languages.asObservable();
  }

  handleChangeLanguage(lan: string, isUser: boolean = true, _language: any = {}) {
    if(isUser){
      this.getLanguagesUrl().subscribe((res: any) => {
        let response = JSON.parse(res._body);
        let selectedLanguage = response.find(x => x.reference === lan);
        this.getLanguages(selectedLanguage.translation_file).subscribe((language: any) => {
          localStorage.setItem('SelectedLanguage', lan);
          localStorage.setItem('language_configs', res._body);
          this.setLanguageConfigs(response);
          this.translate.setTranslation(selectedLanguage.reference.toLocaleLowerCase(), JSON.parse(language._body));
          this.translate.setDefaultLang(selectedLanguage.reference.toLocaleLowerCase());
        }
        )
      })
    }else{
      this.getLanguages(_language.translation_file).subscribe((language: any) => {
        localStorage.setItem('SelectedLanguage', lan);
        this.translate.setTranslation(_language.reference.toLocaleLowerCase(), JSON.parse(language._body));
        this.translate.setDefaultLang(_language.reference.toLocaleLowerCase());
      })
    }
  }
}



// WEBPACK FOOTER //
// /Users/brianyoung/Documents/Development/hfg/datalive-core/gae-web/datalive/client/src/app/_services/language.servic.ts